import { css, keyframes, styled } from 'styled-components';
import { Box } from '@design-system/box';
export const baseUnderlineStyle = (theme) => css `
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: ${theme.colors.primary};
  transform-origin: left center;
  transform: translateX(-50%);
`;
export const underlineAnimation = keyframes `
  from {
    transform: translateX(-50%) scaleX(0);
    transform-origin: left center;
  }
  to {
    transform: translateX(-50%) scaleX(1);
    transform-origin: left center;
  }
`;
const animationOnDesktop = css `
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      &:after {
        opacity: 1;
        animation: ${underlineAnimation} 0.3s ease-out forwards;
      }
    }
  }
`;
export const baseLinkStyles = css `
  color: inherit;
  position: relative;

  &:hover {
    color: inherit;
    text-decoration: inherit;
  }

  &:after {
    ${({ theme }) => baseUnderlineStyle(theme)}
    opacity: ${({ $active }) => (($active !== null && $active !== void 0 ? $active : false) ? 1 : 0)};
    transform: translateX(-50%)
      scaleX(${({ $active }) => (($active !== null && $active !== void 0 ? $active : false) ? 1 : 0)});
  }

  ${animationOnDesktop}
`;
export const ItemComponent = styled(Box).attrs(({ $active, $isMenuItem, $isMobileMenuItem }) => ({
    fontWeight: $active || $isMobileMenuItem ? 1 : 0,
    pt: { _: $isMenuItem ? 1 : 3, m: $isMenuItem ? 1 : 2 },
    pb: { _: $isMenuItem ? 1 : 3, m: $isMenuItem ? 1 : 2 },
    px: 3,
})) `
  cursor: pointer;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  width: min-content;

  ${({ $isMenuItem }) => $isMenuItem &&
    css `
      &:first-child {
        padding-left: 0;
      }
    `};
`;
//# sourceMappingURL=ItemComponent.js.map